import { render } from "./OrgPicker.vue?vue&type=template&id=654a1a26&scoped=true&ts=true"
import script from "./OrgPicker.vue?vue&type=script&lang=ts"
export * from "./OrgPicker.vue?vue&type=script&lang=ts"

import "./OrgPicker.vue?vue&type=style&index=0&id=654a1a26&scoped=true&lang=css"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654a1a26"]])

export default __exports__